<template>
<div>
    <navi selectedid="tlMediaCenter"></navi>
    <subNavi selectedid="tlNews" lastrouter="/media/interaction" nextrouter="/media/video"></subNavi>
    
    <div id="Contents">
        <!-- <div id="Logo">
            <h1 title="Arivo Tyre"><img src="../../common/images/common/logo.png" alt="Arivo Tyre" width="229" height="42"></h1>
            <h2 title="HOME"><a href="../index.html" title="HOME"><img src="../../common/images/top/home.png" alt="HOME" width="229" height="219"></a></h2>

            <siteMenu></siteMenu>
        </div> -->
        <logo selectedid="tlMediaCenter"></logo>

        <spNavi selectedid="tlNews"></spNavi>

        <div id="Main">
            <div class="media-article">
                <h2 title="NEWS">NEWS</h2>
                <h3 class="center">{{title}}</h3><br/>
                <span>{{published_date}}</span>
                <br/><br/>
                <div class="media--img"><img :src="image"></div>
                <div v-html="content"></div>
            </div>

            <share></share>
        </div>
    </div>
    <webFooter></webFooter>
</div>
</template>
<script>
import Navi from "components/common/navi";
import SubNavi from "components/media/subnavi";
import Logo from "components/common/logo";
import SpNavi from "components/media/spnavi";
import Share from "components/common/share";
import WebFooter from "components/common/footer";
import newsApi from "../../api/news-api";
import _util from "../../utils";
export default {
  name: "NewsDetail",
  props: ["id"],
  components: {
    Navi,
    SubNavi,
    Logo,
    SpNavi,
    Share,
    WebFooter
  },
  data() {
    return {
      title: "",
      image: "",
      content: "",
      seo: "",
      seo_description: "",
      published_date: ""
    };
  },
  mounted: function() {
    this.getNewsDetail();
  },
  methods: {
    getNewsDetail() {
      var _this = this;
      newsApi.getNewDetail(
        _this.id,
        function(response) {
          console.log("result: ");
          console.log(response);
          _this.title = response.title;
          _this.image = response.image;
          _this.content = response.content;
          _this.published_date = response.published_date;
          _this.seo = response.seo;
          _this.seo_description = response.seo_description;
          document
            .getElementById("metaKeyword")
            .setAttribute("content", _this.seo);
          document
            .getElementById("metaDescription")
            .setAttribute("content", _this.seo_description);
        },
        function(error) {
          console.log("error: ");
          console.log(error);
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/media/newsdetail.vue